import React from "react";
import "./Expoil.css";

const Expoil = () => {
  return (
    <React.Fragment>
      <div className="expoil">
        <div className="expoil__background">
          <div className="colorImage">
            <div className="expoil__content">
              <div className="expoil__text">
                <h1>We Export World-Class Quality Agric Products</h1>
                <p className="para1">
                  With supply chains linking across continents, Finbarn is
                  deeply involved in enhancing the agricultural potentials of
                  farmers in developing economies.
                </p>
                <p className="para">
                  We strive to exceed our Customers expectations because here in
                  Finbarn, we know that our Customers success and satisfaction
                  is vital to our relationship.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Expoil;
